import { Provider } from "@angular/core";
import { ErrorInterceptorProvider } from "./error.interceptor";

export const INTERCEPTORS: Provider[] = [
  ErrorInterceptorProvider
];
